import { Watch } from "scrollmonitor-react";

const withViewportWatch = (Child) => {
  return Watch(Child);
};

export default withViewportWatch;
